import { NavList } from '@cpm-pr1618001/ng-design-lib';

export const SETTINGS_TABS: NavList[] = [
  { name: 'Profile', id: 0, url: '/settings/profile' },
  { name: 'Billing', id: 1, url: '/settings/billing' },
  { name: 'Plans & Membership', id: 2, url: '/settings/plans-and-membership' },
  { name: 'Account', id: 3, url: '/settings/account' },
];
